import { render, staticRenderFns } from "./settlementDatail.vue?vue&type=template&id=b9cc3756&scoped=true&"
import script from "./settlementDatail.vue?vue&type=script&lang=js&"
export * from "./settlementDatail.vue?vue&type=script&lang=js&"
import style0 from "./settlementDatail.vue?vue&type=style&index=0&id=b9cc3756&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc3756",
  null
  
)

export default component.exports